"use client";

import NextLink from "next/link";

type NextLinkProps = React.ComponentProps<typeof NextLink> &
  Omit<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    keyof React.ComponentProps<typeof NextLink>
  >;

export type LinkProps<TRouterLink extends boolean = false> = {
  useRouterLink?: TRouterLink;
} & (TRouterLink extends true
  ? NextLinkProps
  : React.AnchorHTMLAttributes<HTMLAnchorElement>);

/**
 * Link component that can be used to navigate to a different page and choose between next/link or a regular anchor tag
 */
export const Link = <TRouterLink extends boolean = false>({
  useRouterLink,
  ...props
}: LinkProps<TRouterLink>) =>
  useRouterLink ? (
    <NextLink {...(props as NextLinkProps)} />
  ) : (
    <a {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)} />
  );
